import { EnvironmentOutlined } from "@ant-design/icons"
import { Col, Row, Space, Typography } from "antd"
import { getLocalStorageBrowserLocation } from "helpers/location"
import PropTypes from "prop-types"
import { useMemo } from "react"
import TripLocation from "../../ListingLocation/utils/Location"
const { Title, Text } = Typography

export const PreviewMeetingLocation = ({ trip, t }) => {
  const { address, additional_directions } = trip
  const browserLocation = useMemo(() => getLocalStorageBrowserLocation(), [])
  const tripLatLng = { lat: trip?.latitude, lng: trip?.longitude }
  const centerLatLng = tripLatLng || browserLocation

  return (
    <div className="mt-45">
      <Title className="pb-4" level={3}>
        {t("trip.labels.meeting_location")}
      </Title>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Text>
              <EnvironmentOutlined /> {address}
            </Text>
            <TripLocation height={450} centerLatLng={centerLatLng} meetingLatLng={address} />
            {additional_directions && (
              <>
                <h6 className="py-4 pb-0" style={{ fontWeight: "500" }}>
                  {t("listings.tabs.preview.meeting_instructions")}
                </h6>
                <p>{additional_directions}</p>
              </>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  )
}

PreviewMeetingLocation.propTypes = {
  trip: PropTypes.shape({
    address: PropTypes.string,
    additional_directions: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }).isRequired,
  t: PropTypes.func.isRequired
}
